import { render, staticRenderFns } from "./FermatPrincipleViz.vue?vue&type=template&id=cbf7fe5a&scoped=true"
import script from "./FermatPrincipleViz.vue?vue&type=script&lang=js"
export * from "./FermatPrincipleViz.vue?vue&type=script&lang=js"
import style0 from "./FermatPrincipleViz.vue?vue&type=style&index=0&id=cbf7fe5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf7fe5a",
  null
  
)

export default component.exports